import { Component } from '@angular/core';
import { RouteService } from '@services/route.service';
import { SceneService } from '@services/scene.service';
import { ToastService } from '@services/toast.service';

@Component({
  selector: 'shared-share-btn',
  templateUrl: './share-btn.component.html',
  styleUrls: ['./share-btn.component.css'],
  standalone: false
})
export class ShareBtnComponent {
  public btnEnabled = (key: string): boolean => this.sceneService.selectedScene?.properties?.find(p => p.key == key)?.value as boolean

  constructor(
    public sceneService: SceneService,
    public routeService: RouteService,
    private toastService: ToastService
  ) { }

  public copyShareLink() {
    const link = this.routeService.getCurrentShareLink()
    navigator.clipboard.writeText(link).then(() => {
      this.toastService.toast({ title: 'Link Copied', message: 'Shareable link copied to clipboard', color: 'green' })
    })
  }
}
